import React from "react"
import PropTypes from "prop-types"
import makeStyles from "@material-ui/core/styles/makeStyles"
import Header from "./Header"
import Footer from "./Footer"

const useStyles = makeStyles(theme => ({
  body: {
    background: theme.palette.background.default,
  },
}))
const Layout = ({ children }) => {
  const classes = useStyles()
  return (
    <>
      <Header siteTitle="Gloone" />
      <main className={classes.body}>{children}</main>
      <Footer siteTitle="Gloone" />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
